import CityPageTemplate from "../city-template/CityPageTemplate";
import { longBeachConfig } from "./data";

export default function LongBeachPage() {
  return <CityPageTemplate config={longBeachConfig} />;
}